import React, { useCallback } from 'react';

import {
  ChangeProductsFiltersFunc,
  FetchProductsFilterFields,
  FetchProductsFilters
} from '../../../../../../products/productsTypes';
import { IsDisabled } from '../../../../../../../types';

import { Translate } from '../../../../../../../helpers/Translate';

import { productsKeys } from '../../../../../../../locales/keys';

interface ThreeDStockProductsFiltersBlockedFilterProps {
  productsFilters: FetchProductsFilters;
  disabled?: IsDisabled;
  changeProductsFilters: ChangeProductsFiltersFunc;
}

const name = FetchProductsFilterFields.BLOCKED;
const inputName = 'show-blocked-products';

function ThreeDStockProductsFiltersBlockedFilter({
  productsFilters,
  disabled,
  changeProductsFilters
}: ThreeDStockProductsFiltersBlockedFilterProps) {
  const handleCheck = useCallback(
    () => changeProductsFilters({ [name]: !productsFilters[name] }),
    [changeProductsFilters, productsFilters]
  );

  return (
    <div className="p-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-left flex-1">
            <Translate id={productsKeys.showBlocked} />
          </span>
        </div>

        <div>
          <label
            className="flex items-center relative rounded-full focus-within:ring-base"
            htmlFor={inputName}
          >
            <input
              id={inputName}
              name={inputName}
              disabled={disabled}
              type="checkbox"
              className="sr-only"
              checked={!!productsFilters[name]}
              onChange={handleCheck}
            />
            <div className="toggle-bg-small toggle-bg-blue" />
          </label>
        </div>
      </div>
    </div>
  );
}

export default ThreeDStockProductsFiltersBlockedFilter;
